import { ClipboardCheck, UsersRound } from "lucide-react";
import Reveal from "@/components/Reveal";

const audiences = [
  ["Privatkunden", "wenn Keller, Wohnung oder einzelne Räume wieder frei werden sollen"],
  ["Senioren & Angehörige", "bei kleineren Umzügen, Heimwechseln oder dem Umzug in ein Pflegeheim"],
  ["Rechtliche Betreuer", "wenn eine Wohnung nach Auszug oder im Rahmen eines Nachlasses geräumt werden muss"],
  ["Hausverwaltungen & Makler", "für Wohnungsräumungen und klare nächste Schritte vor einer Übergabe"],
  ["Unternehmen", "für kleinere Gewerberäume, Lager oder einzelne Transporte"],
];

export default function AudienceSection() {
  return (
    <section className="section audience-section section-light" id="fuer-wen" data-testid="audience-section">
      <div className="container audience-grid">
        <Reveal className="audience-intro">
          <span className="eyebrow dark-eyebrow">Für wen wir arbeiten · 04 / 05</span>
          <h2 className="section-title dark-title">Ein Ansprechpartner,<br /><em>wenn es darauf ankommt.</em></h2>
          <p className="section-lead dark-lead">Auch rechtliche Betreuer, Hausverwaltungen und Immobilienmakler finden bei uns einen direkten Ansprechpartner, wenn eine Wohnung nach einem Auszug, Heimwechsel oder Nachlass geräumt werden muss.</p>
          <div className="audience-icons"><span><UsersRound size={19} /> persönlich</span><span><ClipboardCheck size={19} /> strukturiert</span></div>
        </Reveal>
        <div className="audience-list">
          {audiences.map(([title, copy], index) => (
            <Reveal key={title} className="audience-item" delay={index * 55}>
              <article data-testid={`audience-item-${index + 1}`}><span>0{index + 1}</span><div><h3>{title}</h3><p>{copy}</p></div></article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
